<template>
  <div class="reservation-foot">
    <ul class="navbar">
      <li class="nav-item">
        <router-link :to="target">
          <div class="img"></div>
          <p>首页</p>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link to="/personal">
          <img src="../assets/img/nav_02.png" alt="">
          <p>我的预约</p>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { getPlaceId } from '../utils'
export default {
  data () {
    return {
      target: ''
    }
  },
  computed: {
    isIndex () {
      return this.$route.path === '/index' ? '@/assets/img/nav_01_active.png' : '@/assets/img/nav_01.png'
    }
  },
  mounted () {
    if (this.$route.path === '/index') {
      this.target = `/index?placeId=${this.$route.query.placeId}`
    } else {
      this.target = `/index?placeId=${getPlaceId()}`
    }
  }
}
</script>

<style lang="less">
.reservation-foot {
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 750px;
  min-width: 320px;
  height: 1.88rem /* 94/50 */;

  .reservation-btn {
    display: block;
    height: 100%;
    font-size: .8rem /* 40/50 */;
    line-height: 1.88rem /* 94/50 */;
    text-align: center;
    color: #fff;
    background-color: @theme-color;
  }

  .navbar {
    display: flex;
    height: 100%;
    padding: .12rem /* 6/50 */ 0;
    border-top: 1px solid #ccc;
    background-color: #fff;

    .nav-item {
      flex: 1;
      text-align: center;

      img {
        width: .92rem /* 46/50 */;
        height: .92rem /* 46/50 */;
        margin: 0 auto;
      }
      .img {
        width: .92rem /* 46/50 */;
        height: .92rem /* 46/50 */;
        margin: 0 auto;
        background: url('../assets/img/nav_01.png') no-repeat center;
        background-size: 100%;
      }
      p {
        font-size: .4rem /* 20/50 */;
        line-height: .72rem /* 36/50 */;
      }
      .router-link-exact-active.router-link-active {
        color: #159deb;
        .img {
          background: url('../assets/img/nav_01_active.png') no-repeat center;
          background-size: 100%;
        }
      }
    }
  }
}
</style>
